import { Card, CardContent } from "@jambushrushti/components/ui/card";
import { Button } from "@jambushrushti/components/ui/button";
import { Award, Download, Calendar, BookOpen } from "lucide-react";
import { format } from "date-fns";
import type { LMSCertificate } from "@jambushrushti/hooks/useLMSCertificates";

interface CertificateCardProps {
  certificate: LMSCertificate;
  courseName?: string;
  onDownload: (certificate: LMSCertificate) => void;
}

export function CertificateCard({
  certificate,
  courseName,
  onDownload,
}: CertificateCardProps) {
  return (
    <Card className="group overflow-hidden border-primary/10 transition-all duration-300 hover:shadow-lg">
      <div className="border-b border-primary/10 bg-gradient-to-r from-primary/10 to-primary/5 p-4">
        <div className="flex items-center gap-3">
          <div className="rounded-full bg-primary/20 p-3">
            <Award className="h-6 w-6 text-primary" />
          </div>
          <div>
            <h3 className="line-clamp-1 font-semibold text-foreground">
              {courseName || "Course Completion Certificate"}
            </h3>
            <p className="text-sm text-muted-foreground">
              Certificate #{certificate.certificate_number}
            </p>
          </div>
        </div>
      </div>

      <CardContent className="space-y-4 p-4">
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div className="flex items-center gap-2 text-muted-foreground">
            <Calendar className="h-4 w-4" />
            <span>
              Issued:{" "}
              {certificate.issued_at
                ? format(new Date(certificate.issued_at), "MMM dd, yyyy")
                : "N/A"}
            </span>
          </div>
          {certificate.valid_until && (
            <div className="flex items-center gap-2 text-muted-foreground">
              <BookOpen className="h-4 w-4" />
              <span>
                Valid until:{" "}
                {format(new Date(certificate.valid_until), "MMM dd, yyyy")}
              </span>
            </div>
          )}
        </div>

        <Button
          onClick={() => onDownload(certificate)}
          className="w-full gap-2"
          variant="default"
        >
          <Download className="h-4 w-4" />
          Download Certificate
        </Button>
      </CardContent>
    </Card>
  );
}
